import { apiClient } from './client';
import { BoondOpportunity, BoondListResponse, OpportunitiesFilter } from '@gridwise/shared';

export async function getOpportunities(
  filters: OpportunitiesFilter = {},
): Promise<{ data: BoondOpportunity[]; pagination: any }> {
  const response = await apiClient.get('/opportunities', { params: filters });
  return response.data;
}

export async function getOpportunitiesWithoutNextAction(
  filters: OpportunitiesFilter = {},
): Promise<{ data: BoondOpportunity[] }> {
  const response = await apiClient.get('/opportunities/without-next-action', { params: filters });
  return response.data;
}

export async function getOpportunitiesToFollowUp(
  filters: OpportunitiesFilter = {},
): Promise<{ data: BoondOpportunity[] }> {
  const response = await apiClient.get('/opportunities/to-follow-up', { params: filters });
  return response.data;
}

export async function getOpportunityById(id: string): Promise<BoondOpportunity> {
  const response = await apiClient.get(`/opportunities/${id}`);
  return response.data.data;
}
